
import { groupsCollapsedFacet } from '../facets/ScopeFacets';
import { createAsyncActionCreator, IAsyncActionCreator } from '../store/actions/createActionCreator';
import { IItemCacheThunkAction, IItemCacheDispatch } from '../store/actions/ItemCacheActions';
import { resolveItems } from './getItems';

/**
 * @public
 */
export interface IToggleCollapseGroupPayload {
  itemsScopeItemKey: string;
  groupKey: string;
  isCollapsed: boolean;
}

export const toggleCollapseGroup: IAsyncActionCreator<IToggleCollapseGroupPayload, IItemCacheThunkAction<void>> = createAsyncActionCreator((
  payload: IToggleCollapseGroupPayload): IItemCacheThunkAction<void> => {
  let {
    itemsScopeItemKey,
    groupKey,
    isCollapsed
  } = payload;

  return (dispatch: IItemCacheDispatch) => {
    dispatch(resolveItems({
      items: {
        [itemsScopeItemKey]: {
          ...groupsCollapsedFacet.pack({
            [groupKey]: !isCollapsed
          })
        }
      }
    }));
  };
});
